const { calculateEstimatedMonthlyCost } = require('./calculate-estimated-monthly-cost')
const { calculatePresentValue } = require('./calculate-present-value')
const { generatePayment } = require('./generate-payment')

/**
 * @param {number} amount
 * @param {number} duration
 * @param {number} interest
 * @param {number} startupFee
 * @param {number} monthlyFee
 * @returns {*}
 */
function calculateRate ({ amount, duration, interest, startupFee = 0, monthlyFee = 0 } = {}) {
  if (!amount || !duration || !interest) return

  const monthlyInterest = interest / 12
  const payment = -generatePayment({
    interestRate: monthlyInterest,
    numberOfPeriods: duration,
    presentValue: amount,
    futureValue: 0,
    type: 0
  })

  let currentBalance = amount

  const loanRows = []

  loanRows.push({
    payment: 0,
    interest: 0,
    startupFee: startupFee,
    monthlyFee: 0,
    principal: 0,
    balance: currentBalance,
    presentValue: 0
  })

  let tempBalance = 0
  let tempPaymentInterest = 0
  let tempPrincipal = 0

  for (let i = 0; i < duration; i++) {
    tempPaymentInterest = currentBalance * monthlyInterest
    tempPrincipal = payment - tempPaymentInterest
    tempBalance = currentBalance - tempPrincipal

    if (tempBalance < 0) {
      tempBalance = 0
    }

    loanRows.push({
      payment,
      interest: tempPaymentInterest,
      startupFee: 0,
      monthlyFee,
      principal: tempPrincipal,
      balance: tempBalance,
      presentValue: 0
    })

    currentBalance = tempBalance
  }

  let diff
  let counter = 0
  let estimatedAverageInterest = interest
  let estimatedMonthlyPercentageRate
  let sign
  let totalCost

  while (true) {
    totalCost = 0
    estimatedMonthlyPercentageRate = calculateEstimatedMonthlyCost({ estimatedAverageInterest })

    for (let i = 0; i < loanRows.length; i++) {
      loanRows[i].presentValue = calculatePresentValue({
        payment: loanRows[i].payment,
        startupFee: loanRows[i].startupFee,
        monthlyFee: loanRows[i].monthlyFee,
        estimatedPeriodRate: estimatedMonthlyPercentageRate,
        iteration: i
      })

      totalCost += loanRows[i].payment
      totalCost += loanRows[i].startupFee
      totalCost += loanRows[i].monthlyFee
    }

    let totalPV = 0

    for (let i = 0; i < loanRows.length; i++) {
      totalPV += loanRows[i].presentValue
    }

    diff = Math.round(amount - totalPV)
    sign = 1

    if (diff < 0) {
      sign = -1
    }

    if (Math.round(((sign * diff) / amount) * 100000) === 0) {
      break
    }

    estimatedAverageInterest += (-diff / amount) * estimatedAverageInterest

    counter++

    if (counter > 100) {
      break
    }
  }

  const returnObject = {}

  returnObject.estimatedAvgInterest = (estimatedAverageInterest * 100)
  returnObject.totalCost = totalCost

  return returnObject
}

module.exports = { calculateRate }
